<script lang="ts">
  import { bannerInfo } from '$components/banner.svelte';
  import Drawer from '$components/drawer.svelte';

  import { navbarInfo } from '$components/navigation/navbar.svelte';
  import { aboveLg } from '$lib/stores/breakpoints';
  import { cn } from '$lib/utils';
  import { createEventDispatcher } from 'svelte';

  export let expanded = false;
  const dispatch = createEventDispatcher<{
    submit: Event & { currentTarget: EventTarget & HTMLFormElement };
  }>();

  const getEventTarget = (
    e: Event & {
      currentTarget: EventTarget & HTMLFormElement;
    }
  ) => (e.target instanceof HTMLInputElement ? e.target : null);
</script>

<!-- this form will handle the submission of sort and filters -->
<form
  id="filters"
  class="px-2 lg:px-8 pb-12"
  method="get"
  data-sveltekit-noscroll
  on:change={(e) => {
    if (getEventTarget(e)?.attributes.getNamedItem('form')?.value === 'filters') {
      dispatch('submit', e);
      e.currentTarget.requestSubmit();
    }
  }}
>
  <div class="container mx-auto">
    <slot name="top" />

    <div class="flex gap-8">
      <div class="grow h-full">
        {#if $$slots.default}
          <slot />
        {/if}
        <slot name="load-more" />
      </div>

      {#if $aboveLg}
        <aside class={cn('min-w-[332px] max-w-[332px]', expanded ? 'block' : 'hidden')}>
          <div
            class="sticky max-h-[calc(100dvh_-_var(--navbar-height))] overflow-auto top-[--navbar-height] overscroll-contain"
            style="--navbar-height: {($navbarInfo?.rect.height || 65) +
              ($bannerInfo.isSticky ? $bannerInfo.rect?.height || 56 : 0) +
              15 +
              'px'}"
          >
            <slot name="sidebar" />
          </div>
        </aside>
      {:else}
        <Drawer id="filters" portalTarget="#filters-portal-target">
          <div class="px-4 pt-7 h-full">
            <slot name="sidebar" />
          </div>
        </Drawer>
      {/if}
    </div>
  </div>
  <div id="filters-portal-target" />
</form>
